import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
// import { useStore } from '@mcn-platform/models';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../common/PlaceHolder';
import Meeting from './Meeting';
const MeetingDeliveryWidget = ({ meetingKey, settings, editData, limitToPageWidth, }) => {
    const { currentOrganization } = useStore();
    console.log('MeetingDeliveryWidget', { meetingKey, editData, currentOrganization });
    if (!currentOrganization?.enableMeetings) {
        if (editData) {
            return (_jsx(PlaceHolder, { placeHolderName: "Meeting Features not enabled" }));
        }
        console.log('MeetingDeliveryWidget: Meeting Features not enabled');
        return null;
    }
    const isEmpty = () => (!meetingKey);
    if (editData && isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Meeting" }));
    }
    if (!meetingKey) {
        console.log('MeetingDeliveryWidget: meetingKey is not defined');
        return null;
    }
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(Meeting, { meetingKey: meetingKey, settings: settings }) }));
};
MeetingDeliveryWidget.defaultProps = {
    settings: undefined,
    limitToPageWidth: false,
};
MeetingDeliveryWidget.meta = {
    group: 'portal',
    name: 'Meeting Delivery',
    description: 'UI to manage and participate in meetings.',
    props: [
        {
            key: 'meetingKey',
            name: 'Meeting',
            type: 'meeting',
            description: 'Meeting that will be presented.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        // for Meeting Summary
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show title',
        },
        {
            key: 'settings.showVideo',
            name: 'Show Image or Video',
            type: 'boolean',
            description: 'Show the intro video on the card',
        },
        {
            key: 'settings.showInfo',
            name: 'Show Info Bar',
            type: 'boolean',
            description: 'Show the meeting info on the card',
        },
        {
            key: 'settings.showHeadline',
            name: 'Show Headline',
            type: 'boolean',
            description: 'Show the meeting headline on the card',
        },
        {
            key: 'settings.showDescription',
            name: 'Show Description',
            type: 'boolean',
            description: 'Show the meeting description on the card',
        },
        {
            key: 'settings.showInstructor',
            name: 'Show Instructor',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        {
            key: 'settings.showActionButton',
            name: 'Show Call to Action Button',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        // for Post Meeting Recording
        {
            key: 'settings.showKicker',
            name: 'Show Kicker',
            type: 'boolean',
            description: 'Show the kicker widget if applicable.',
        },
        {
            key: 'settings.showNotes',
            name: 'Show Notes',
            type: 'boolean',
            description: 'Show the notes panel on the right side.',
        },
        {
            key: 'settings.showTranscript',
            name: 'Show Transcript Tab',
            type: 'boolean',
            description: 'Show the transcript tab below the video.',
        },
        {
            key: 'settings.showAgenda',
            name: 'Show Agenda Tab',
            type: 'boolean',
            description: 'Show the agenda (description) tab below the video.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MeetingDeliveryWidget',
        props: {
            meetingKey: '@meetingKey',
            layout: {
                padding: {
                    top: 8,
                    left: 8,
                    right: 8,
                    bottom: 8,
                },
            },
            settings: {
                showTitle: true,
                showVideo: true,
                showInfo: true,
                showHeadline: true,
                showInstructor: true,
                showActionButton: true,
                showDescription: true,
                showKicker: true,
                showNotes: true,
                showTranscript: true,
                showAgenda: true,
            },
        },
    },
};
export default observer(MeetingDeliveryWidget);
//# sourceMappingURL=MeetingDeliveryWidget.js.map